import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
// NEU: Icon und Theme importieren
import { FiAlertTriangle } from 'react-icons/fi';
import { theme } from '../../styles/theme'; // Pfad ggf. anpassen
import ChatMessage from './ChatMessage';

const ChatHistory = ({ messages }) => {
  const messagesEndRef = useRef(null);

  // Auto-scroll to bottom when messages change
  useEffect(() => {
    // Nur scrollen, wenn Nachrichten vorhanden sind
    if (messages && messages.length > 0) {
      messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    }
  }, [messages]);

  // Wenn keine Nachrichten vorhanden sind, zeige den Willkommenstext UND den Disclaimer
  if (!messages || messages.length === 0) {
    return (
      <EmptyChatContainer>
        <EmptyChatText>
          Keine Nachrichten. Starten Sie eine neue Analyse oder stellen Sie eine
          Frage im Eingabefeld unten.
        </EmptyChatText>
        {/* --- NEUER WARNHINWEIS --- */}
        <DisclaimerBox>
          <DisclaimerIcon>
            <FiAlertTriangle size={20} />
          </DisclaimerIcon>
          <DisclaimerText>
            <strong>Wichtiger Hinweis:</strong> KI-Ergebnisse können Fehler
            enthalten ('Halluzinationen'). Überprüfen Sie alle Informationen
            sorgfältig. Dies ist keine Rechtsberatung, keine Haftung für
            Richtigkeit.
          </DisclaimerText>
        </DisclaimerBox>
        {/* --- ENDE WARNHINWEIS --- */}
      </EmptyChatContainer>
    );
  }

  // Wenn Nachrichten vorhanden sind, zeige die Nachrichten an
  return (
    <Container>
      {messages.map((message) => (
        // Sicherstellen, dass jede Nachricht eine eindeutige ID hat
        <ChatMessage key={message.id || `msg-${Math.random()}`} message={message} />
      ))}
      {/* Leeres div am Ende für das Auto-Scrolling */}
      <div ref={messagesEndRef} />
    </Container>
  );
};

// --- Styled Components ---

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-bottom: 1rem; // Etwas Platz am Ende lassen
`;

// Container für den leeren Zustand, um Text und Disclaimer zu gruppieren
const EmptyChatContainer = styled.div`
  display: flex;
  flex-direction: column; // Untereinander anordnen
  align-items: center; // Zentriert horizontal
  justify-content: center; // Zentriert vertikal (wenn Höhe vorhanden)
  padding: 2rem;
  text-align: center;
  height: 100%; // Versucht, den verfügbaren Platz einzunehmen
  min-height: 200px; // Mindesthöhe, damit es nicht zu klein wird
`;

const EmptyChatText = styled.div`
  color: ${({ theme }) => theme.colors.textLight};
  font-style: italic;
  margin-bottom: 2rem; // Abstand zum Disclaimer
  font-size: 1rem;
`;

// --- WARNHINWEIS STYLES (kopiert von ChatPage für Konsistenz) ---
const DisclaimerBox = styled.div`
  background-color: ${theme.colors.warningBackground || '#fffbe6'};
  color: ${theme.colors.warningText || '#8a6d3b'};
  border: 1px solid ${theme.colors.warningBorder || '#ffeeba'};
  border-radius: ${theme.borderRadius.md};
  padding: ${theme.spacing.md};
  margin-top: ${theme.spacing.lg}; // Abstand zum oberen Text
  display: flex;
  align-items: flex-start;
  gap: ${theme.spacing.md};
  max-width: 650px; // Maximale Breite beibehalten
  text-align: left; // Text linksbündig
`;

const DisclaimerIcon = styled.div`
  flex-shrink: 0;
  margin-top: 3px;
  color: ${theme.colors.warning || '#ffc107'};
`;

const DisclaimerText = styled.p`
  font-size: 0.9rem;
  line-height: 1.5;
  margin: 0;

  strong {
    color: inherit;
    font-weight: 600;
  }
`;
// --- ENDE WARNHINWEIS STYLES ---

export default ChatHistory;
